<template>
  <div :class="space == false  ? '': 'py-2' ">    
    <label v-if="label" class="block text-sm  " :class="dark ? 'text-white' : 'text-gray-700' ">{{label}}</label>
    <div v-if="description" class="text-gray-500 text-xs" :class="dark ? 'text-white' : 'text-gray-500' ">
      {{description}}
    </div>
    
  </div>
</template>

<script>

export default {
    name: 'Text',
    props: {
        label: String,
        description: String,
        space: Boolean,
        dark: Boolean,
    },

}
</script>